import { EMPTY_LIST } from '../../../../../constants/common'
import { LISTING_PORTAL_SYNC_STATUS } from '../../../../RentalPortalListing'

export const QA_NAME_LISTING_PROFILE_PUBLISHINGS_RETRY =
  'listingPublishingsRetry'

export const QA_NAME_LISTING_PROFILE_PUBLISHINGS_TABLE = 'listingPublishings'

export const LISTING_PROFILE_PUBLISHINGS_SKELETON_ROWS = 2

export const LISTING_PUBLICATION_COLUMN_NAME = {
  Actions: 'actions',
  ExternalId: 'external_listing_id',
  LastSync: 'last_action_at',
  Portal: 'portal',
  Scheduled: 'scheduled_publish_at',
  Status: 'sync_status',
}

// TODO: the tab runs on fixed columns until the backend registers its table
// config and the table loads it through useTableConfigLoader
export const LISTING_PUBLICATION_COLUMNS_CONFIG = {
  [LISTING_PUBLICATION_COLUMN_NAME.Actions]: {
    index: 5,
    name: LISTING_PUBLICATION_COLUMN_NAME.Actions,
    ordering_field: null,
    title: 'RentalPortal.ListingProfilePublishingsActionsColumnKey',
    visible: true,
    width: 270,
  },
  [LISTING_PUBLICATION_COLUMN_NAME.ExternalId]: {
    index: 2,
    name: LISTING_PUBLICATION_COLUMN_NAME.ExternalId,
    ordering_field: null,
    title: 'RentalPortal.ListingProfilePublishingsExternalIdColumnKey',
    visible: true,
    width: 210,
  },
  [LISTING_PUBLICATION_COLUMN_NAME.LastSync]: {
    index: 3,
    name: LISTING_PUBLICATION_COLUMN_NAME.LastSync,
    ordering_field: null,
    title: 'RentalPortal.ListingProfilePublishingsLastSyncColumnKey',
    visible: true,
    width: 180,
  },
  [LISTING_PUBLICATION_COLUMN_NAME.Portal]: {
    index: 0,
    name: LISTING_PUBLICATION_COLUMN_NAME.Portal,
    ordering_field: null,
    title: 'RentalPortal.ListingProfilePublishingsPortalColumnKey',
    visible: true,
    width: 240,
  },
  [LISTING_PUBLICATION_COLUMN_NAME.Scheduled]: {
    index: 4,
    name: LISTING_PUBLICATION_COLUMN_NAME.Scheduled,
    ordering_field: null,
    title: 'RentalPortal.ListingProfilePublishingsScheduledColumnKey',
    visible: true,
    width: 180,
  },
  [LISTING_PUBLICATION_COLUMN_NAME.Status]: {
    index: 1,
    name: LISTING_PUBLICATION_COLUMN_NAME.Status,
    ordering_field: null,
    title: 'RentalPortal.ListingProfilePublishingsStatusColumnKey',
    visible: true,
    width: 150,
  },
}

export const LISTING_PUBLICATIONS_STATE = {
  empty: 'empty',
  error: 'error',
  loading: 'loading',
  table: 'table',
}

export const LISTING_PUBLICATION_ACTION = {
  cancelDeactivation: 'cancel-deactivation',
  cancelSchedule: 'cancel-schedule',
  deactivate: 'deactivate',
  details: 'details',
  editDeactivation: 'edit-deactivation',
  editSchedule: 'edit-schedule',
  openAd: 'open-ad',
  publish: 'publish',
  publishNow: 'publish-now',
  republish: 'republish',
  resend: 'resend',
  retry: 'retry',
  transferChanges: 'transfer-changes',
}

export const LISTING_PUBLICATION_ACTION_LABEL_KEY = {
  [LISTING_PUBLICATION_ACTION.cancelDeactivation]:
    'RentalPortal.ListingPublicationCancelDeactivationBtnKey',
  [LISTING_PUBLICATION_ACTION.cancelSchedule]:
    'RentalPortal.ListingPublicationCancelScheduleBtnKey',
  [LISTING_PUBLICATION_ACTION.deactivate]:
    'RentalPortal.ListingPublicationDeactivateBtnKey',
  [LISTING_PUBLICATION_ACTION.details]:
    'RentalPortal.ListingPublicationDetailsBtnKey',
  [LISTING_PUBLICATION_ACTION.editDeactivation]:
    'RentalPortal.ListingPublicationEditDeactivationBtnKey',
  [LISTING_PUBLICATION_ACTION.editSchedule]:
    'RentalPortal.ListingPublicationEditScheduleBtnKey',
  [LISTING_PUBLICATION_ACTION.openAd]:
    'RentalPortal.ListingPublicationOpenAdBtnKey',
  [LISTING_PUBLICATION_ACTION.publish]:
    'RentalPortal.ListingPublicationPublishBtnKey',
  [LISTING_PUBLICATION_ACTION.publishNow]:
    'RentalPortal.ListingPublicationPublishNowBtnKey',
  [LISTING_PUBLICATION_ACTION.republish]:
    'RentalPortal.ListingPublicationRepublishBtnKey',
  [LISTING_PUBLICATION_ACTION.resend]:
    'RentalPortal.ListingPublicationResendBtnKey',
  [LISTING_PUBLICATION_ACTION.retry]:
    'RentalPortal.ListingPublicationRetryBtnKey',
  [LISTING_PUBLICATION_ACTION.transferChanges]:
    'RentalPortal.ListingPublicationTransferChangesBtnKey',
}

export const LISTING_PUBLICATION_DISPATCH_ACTIONS = [
  LISTING_PUBLICATION_ACTION.cancelDeactivation,
  LISTING_PUBLICATION_ACTION.cancelSchedule,
  LISTING_PUBLICATION_ACTION.deactivate,
  LISTING_PUBLICATION_ACTION.editDeactivation,
  LISTING_PUBLICATION_ACTION.editSchedule,
  LISTING_PUBLICATION_ACTION.publish,
  LISTING_PUBLICATION_ACTION.publishNow,
  LISTING_PUBLICATION_ACTION.republish,
  LISTING_PUBLICATION_ACTION.resend,
  LISTING_PUBLICATION_ACTION.retry,
  LISTING_PUBLICATION_ACTION.transferChanges,
]

export const LISTING_PUBLICATION_SCHEDULE_FIELD = {
  [LISTING_PUBLICATION_ACTION.editDeactivation]: 'scheduled_deactivate_at',
  [LISTING_PUBLICATION_ACTION.editSchedule]: 'scheduled_publish_at',
}

export const LISTING_PUBLICATION_PUBLISH_ACTIONS = [
  LISTING_PUBLICATION_ACTION.publish,
  LISTING_PUBLICATION_ACTION.publishNow,
  LISTING_PUBLICATION_ACTION.republish,
]

export const LISTING_PUBLICATION_BLOCKED_DRAFT_ACTIONS = [
  ...LISTING_PUBLICATION_PUBLISH_ACTIONS,
  LISTING_PUBLICATION_ACTION.editSchedule,
]

export const LISTING_PUBLICATION_READINESS_ACTIONS = [
  LISTING_PUBLICATION_ACTION.editSchedule,
  LISTING_PUBLICATION_ACTION.publish,
  LISTING_PUBLICATION_ACTION.publishNow,
  LISTING_PUBLICATION_ACTION.republish,
  LISTING_PUBLICATION_ACTION.resend,
  LISTING_PUBLICATION_ACTION.retry,
  LISTING_PUBLICATION_ACTION.transferChanges,
]

export const LISTING_PUBLICATION_SCHEDULED_DEACTIVATE_ACTIONS = [
  LISTING_PUBLICATION_ACTION.cancelDeactivation,
  LISTING_PUBLICATION_ACTION.editDeactivation,
]

export const LISTING_PUBLICATION_IN_PROGRESS_SYNC_STATUSES = [
  LISTING_PORTAL_SYNC_STATUS.deactivating,
  LISTING_PORTAL_SYNC_STATUS.publishing,
  LISTING_PORTAL_SYNC_STATUS.updating,
]

export const LISTING_PUBLICATION_NOT_PUBLISHED_ROW = {
  external_listing_id: null,
  last_action_at: null,
  last_error: null,
  public_url: null,
  scheduled_deactivate_at: null,
  scheduled_publish_at: null,
  sync_status: LISTING_PORTAL_SYNC_STATUS.notPublished,
}

export const LISTING_PUBLICATION_STATE_ACTIONS = {
  [LISTING_PORTAL_SYNC_STATUS.deactivated]: {
    options: EMPTY_LIST,
    primary: LISTING_PUBLICATION_ACTION.republish,
  },
  [LISTING_PORTAL_SYNC_STATUS.deactivating]: {
    options: EMPTY_LIST,
    primary: null,
  },
  [LISTING_PORTAL_SYNC_STATUS.error]: {
    options: [
      LISTING_PUBLICATION_ACTION.details,
      LISTING_PUBLICATION_ACTION.deactivate,
    ],
    primary: LISTING_PUBLICATION_ACTION.retry,
  },
  [LISTING_PORTAL_SYNC_STATUS.notPublished]: {
    options: EMPTY_LIST,
    primary: LISTING_PUBLICATION_ACTION.publish,
  },
  [LISTING_PORTAL_SYNC_STATUS.published]: {
    options: [
      LISTING_PUBLICATION_ACTION.resend,
      LISTING_PUBLICATION_ACTION.editDeactivation,
      LISTING_PUBLICATION_ACTION.cancelDeactivation,
      LISTING_PUBLICATION_ACTION.deactivate,
    ],
    primary: LISTING_PUBLICATION_ACTION.openAd,
  },
  [LISTING_PORTAL_SYNC_STATUS.publishing]: {
    options: EMPTY_LIST,
    primary: null,
  },
  [LISTING_PORTAL_SYNC_STATUS.queued]: {
    options: [
      LISTING_PUBLICATION_ACTION.publishNow,
      LISTING_PUBLICATION_ACTION.cancelSchedule,
    ],
    primary: LISTING_PUBLICATION_ACTION.editSchedule,
  },
  [LISTING_PORTAL_SYNC_STATUS.updatePending]: {
    options: [
      LISTING_PUBLICATION_ACTION.openAd,
      LISTING_PUBLICATION_ACTION.deactivate,
    ],
    primary: LISTING_PUBLICATION_ACTION.transferChanges,
  },
  [LISTING_PORTAL_SYNC_STATUS.updating]: { options: EMPTY_LIST, primary: null },
}

export const LISTING_PUBLICATION_ACTION_CONFIRMATION_KEY = {
  [LISTING_PUBLICATION_ACTION.cancelDeactivation]:
    'RentalPortal.ListingPublicationCancelDeactivationConfirmationTextKey',
  [LISTING_PUBLICATION_ACTION.cancelSchedule]:
    'RentalPortal.ListingPublicationCancelScheduleConfirmationTextKey',
  [LISTING_PUBLICATION_ACTION.deactivate]:
    'RentalPortal.ListingPublicationDeactivateConfirmationTextKey',
  [LISTING_PUBLICATION_ACTION.publish]:
    'RentalPortal.ListingPublicationPublishConfirmationTextKey',
  [LISTING_PUBLICATION_ACTION.publishNow]:
    'RentalPortal.ListingPublicationPublishNowConfirmationTextKey',
  [LISTING_PUBLICATION_ACTION.republish]:
    'RentalPortal.ListingPublicationRepublishConfirmationTextKey',
  [LISTING_PUBLICATION_ACTION.resend]:
    'RentalPortal.ListingPublicationResendConfirmationTextKey',
  [LISTING_PUBLICATION_ACTION.retry]:
    'RentalPortal.ListingPublicationRetryConfirmationTextKey',
  [LISTING_PUBLICATION_ACTION.transferChanges]:
    'RentalPortal.ListingPublicationTransferChangesConfirmationTextKey',
}

export const LISTING_PUBLICATION_ACTION_NOTIFICATION_KEY = {
  [LISTING_PUBLICATION_ACTION.cancelDeactivation]:
    'RentalPortal.ListingPublicationScheduleCancelledNotificationKey',
  [LISTING_PUBLICATION_ACTION.cancelSchedule]:
    'RentalPortal.ListingPublicationScheduleCancelledNotificationKey',
  [LISTING_PUBLICATION_ACTION.deactivate]:
    'RentalPortal.ListingPublicationDeactivateStartedNotificationKey',
  [LISTING_PUBLICATION_ACTION.editDeactivation]:
    'RentalPortal.ListingPublicationScheduleSavedNotificationKey',
  [LISTING_PUBLICATION_ACTION.editSchedule]:
    'RentalPortal.ListingPublicationScheduleSavedNotificationKey',
  [LISTING_PUBLICATION_ACTION.publish]:
    'RentalPortal.ListingPublicationPublishStartedNotificationKey',
  [LISTING_PUBLICATION_ACTION.publishNow]:
    'RentalPortal.ListingPublicationPublishStartedNotificationKey',
  [LISTING_PUBLICATION_ACTION.republish]:
    'RentalPortal.ListingPublicationPublishStartedNotificationKey',
  [LISTING_PUBLICATION_ACTION.resend]:
    'RentalPortal.ListingPublicationUpdateStartedNotificationKey',
  [LISTING_PUBLICATION_ACTION.transferChanges]:
    'RentalPortal.ListingPublicationUpdateStartedNotificationKey',
}

export const LISTING_PUBLICATION_LAST_ACTION = {
  deactivate: 'deactivate',
  publish: 'publish',
  update: 'update',
}

export const LISTING_PUBLICATION_RETRY_NOTIFICATION_KEY = {
  [LISTING_PUBLICATION_LAST_ACTION.deactivate]:
    'RentalPortal.ListingPublicationDeactivateStartedNotificationKey',
  [LISTING_PUBLICATION_LAST_ACTION.publish]:
    'RentalPortal.ListingPublicationPublishStartedNotificationKey',
  [LISTING_PUBLICATION_LAST_ACTION.update]:
    'RentalPortal.ListingPublicationUpdateStartedNotificationKey',
}

export const LISTING_PUBLICATION_RETRY_GATE_ACTION = {
  [LISTING_PUBLICATION_LAST_ACTION.deactivate]:
    LISTING_PUBLICATION_ACTION.deactivate,
  [LISTING_PUBLICATION_LAST_ACTION.publish]: LISTING_PUBLICATION_ACTION.publish,
}

export const LISTING_PUBLICATION_SCHEDULE_TYPE = {
  deactivate: 'deactivate',
  publish: 'publish',
}

export const LISTING_PUBLICATION_SCHEDULE_MODAL_PROPS = {
  [LISTING_PUBLICATION_ACTION.editDeactivation]: {
    labelKey: 'RentalPortal.ListingPublicationDeactivateAtLabelKey',
    titleKey: 'RentalPortal.ListingPublicationDeactivationModalTitleKey',
  },
  [LISTING_PUBLICATION_ACTION.editSchedule]: {
    labelKey: 'RentalPortal.ListingPublicationPublishAtLabelKey',
    titleKey: 'RentalPortal.ListingPublicationScheduleModalTitleKey',
  },
}
